/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationStoreCheckBuyProductsCheckBuyProductsData interface.
 */
export function instanceOfFxIdApplicationStoreCheckBuyProductsCheckBuyProductsData(value) {
    if (!('Sku' in value) || value['Sku'] === undefined)
        return false;
    if (!('CanBePurchased' in value) || value['CanBePurchased'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationStoreCheckBuyProductsCheckBuyProductsDataFromJSON(json) {
    return FxIdApplicationStoreCheckBuyProductsCheckBuyProductsDataFromJSONTyped(json, false);
}
export function FxIdApplicationStoreCheckBuyProductsCheckBuyProductsDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Sku': json['Sku'],
        'CanBePurchased': json['CanBePurchased'],
        'ClientMetadata': json['ClientMetadata'] == null ? undefined : json['ClientMetadata'],
    };
}
export function FxIdApplicationStoreCheckBuyProductsCheckBuyProductsDataToJSON(json) {
    return FxIdApplicationStoreCheckBuyProductsCheckBuyProductsDataToJSONTyped(json, false);
}
export function FxIdApplicationStoreCheckBuyProductsCheckBuyProductsDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Sku': value['Sku'],
        'CanBePurchased': value['CanBePurchased'],
        'ClientMetadata': value['ClientMetadata'],
    };
}
//# sourceMappingURL=FxIdApplicationStoreCheckBuyProductsCheckBuyProductsData.js.map